<template>
  <section class="payment-record">
    <h2>Payment Record</h2>
    <div class="abs-top-right">
      <v-button
        v-if="isManual&&isSme"
        type="primary"
        plain
        @click="onAddRecord">Add New Record</v-button>
    </div>
    <section
      v-for="(item, index) in records"
      :key="index">
      <span
        v-if="!isManual"
        class="title">
        Policy Period
        <span class="date">{{ item.period }}</span>
      </span>
      <div class="transparent">
        <!-- <el-table
          :data="item.record"
          stripe
          style="width: 100%">
          <el-table-column
            prop="type_language"
            label="Type"></el-table-column>
          <el-table-column
            prop="success_at"
            label="Transaction Date"></el-table-column>
          <el-table-column
            prop="method"
            label="Method"></el-table-column>
          <el-table-column
            prop="amount"
            label="Amount"></el-table-column>
          <el-table-column
            prop="holder"
            label="Card Holder"></el-table-column>
          <el-table-column
            prop="number"
            label="Reference No."></el-table-column>
          <el-table-column
            label="Proof">
            <template slot-scope="scope">
              <span
                v-if="scope.row.proof"
                class="link"
                @click="openFile(scope.row.proof.file_url)">{{ scope.row.proof.file_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="Remark">
          </el-table-column>
          <el-table-column
            v-if="isSme"
            label="Action">
            <template slot-scope="scope">
              <v-button
                v-if="scope.row.type != 4"
                type="text"
                @click="editPaymentDialog(scope.row)">Edit</v-button>
            </template>  
          </el-table-column>
        </el-table> -->
        <el-table
          :expand-row-keys="expands"
          :row-key="setRowKey"
          :data="item.record"
          style="width: 100%"
          :header-row-class-name="'tableHeader'">
          <el-table-column
            label="Date"
            min-width="80">
            <template #default="{row}">
              <div class="flex-column">
                <span>{{row.success_at.split(' ')[0]}}</span>
                <span>{{row.success_at.split(' ')[1]}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Reason"
            prop="type_language"
            class-name="fz14"
            min-width="120"></el-table-column>
          <el-table-column
            label="Amount"
            prop="amount"
            class-name="fz14"
            min-width="90"></el-table-column>
          <el-table-column
            label="Methods"
            min-width="120">
            <template #default="{row}">
              <div class="flex-column">
                <span
                  v-for="(item, i) in row.method"
                  :key="i">{{item}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="User"
            prop="holder"
            min-width="140"></el-table-column>
          <el-table-column
            align="right"
            width="65">
            <template #default="{row}">
              <font-awesome-icon
                :icon="expands.includes(row.id)? 'minus-square' : 'plus-square'"
                class="pointer"
                @click="handleExpand(row)"></font-awesome-icon>
            </template>
          </el-table-column>
          <el-table-column
            width="1"
            class-name="hide"
            type="expand">
            <template #default="{row}">
              <el-table
                :data="row.sub_items"
                :row-class-name="'expandRow'"
                :header-row-class-name="'expandTableHeader'">
                <el-table-column
                  label="Date"
                  min-width="80">
                  <template #default="{row}">
                    <div class="flex-column">
                      <span>{{row.success_at.split(' ')[0]}}</span>
                      <span>{{row.success_at.split(' ')[1]}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Method"
                  min-width="120"
                  prop="method"></el-table-column>
                <el-table-column
                  label="Amount"
                  min-width="90"
                  prop="amount"></el-table-column>
                <el-table-column
                  label="Reference"
                  min-width="120"
                  prop="number"></el-table-column>
                <el-table-column
                  label="Remark"
                  min-width="140"
                  prop="remark"></el-table-column>
                <el-table-column width="65">
                  <template #default="{row}">
                    <span
                      v-if="row.proof"
                      class="blue pointer nowrap"
                      @click="openFile(row.proof.file_url)">Proof</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>

    <add-payment-record
      ref="add-payment-record"
      :editPayment="editPayment"
      :paymentForm="paymentForm"
      @updateData ="reloadData" />
  </section>
</template>
<script>
import AddPaymentRecord from './dialog/add-payment-record'
export default {
  name: 'PaymentRecord',
  components: {
    AddPaymentRecord
  },
  props: {
    records: {
      type: Array,
      default: () => ([])
    },
    isManual: {
      type: Boolean,
      default: false
    },
    class_id:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableData: [],
      paymentForm:{},
      editPayment:false,
      expands: [],  //需要展开的行的id
    }
  },
  computed:{
    isSme(){
      let data = [51,52,53,54,55,56,57,58,59,60,61,62]
      let isHasSme = data.indexOf(this.class_id)
      return isHasSme!=-1?true:false
    },
  },

  methods: {
    onAddRecord() {
      // this.editPayment =false
      // this.$refs['add-payment-record'].changeDialog()
      this.$emit('add-record')
    },
    editPaymentDialog(item){
      const { type } = item
      if(type != 4) {
        this.editPayment =true
        this.paymentForm = item
        this.$refs['add-payment-record'].changeDialog()
      }
    },
    reloadData(){
      this.paymentForm ={}
      this.editPayment = false
      this.$emit('refresh')
    },
    openFile(url){
      if(url) {
        window.open(url,'_blank')
      }
    },
    setRowKey(row){
      return row.id
    },
    handleExpand(row){
      // 让对应的行展开
      const {id} = row
      if(this.expands.includes(id)){
        this.expands = this.expands.filter(item => item != id)
      }else{
        this.expands.push(id)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.payment-record {
  position: relative;
    .title {
        padding-bottom: 15px;
        font-size: 20px;
        font-weight: bold;
        .date {
            padding-left: 15px;
            font-size: 18px;
            font-weight: 500;
        }
    }
    .transparent {
      margin-bottom: 15px;
    }
  .link{
    color: #3FBEE5;
    cursor:pointer;
  }
}
.nowrap{
  white-space: nowrap;
}
/deep/.fz14{
  font-size: 14px;
}
/deep/.el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  font-size: 12px;
  color: #24292E;
  tr{
    td{
      padding: 12px 15px!important;
      vertical-align: top;
      margin-right: 15px;
     .cell{
       line-height: 23px;
       position: relative;
       height: inherit;
       padding: 0;
     }
    }
  }
}
/deep/.tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 12px 15px!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
}
/deep/ .el-table__expand-icon{
  visibility: hidden;
}
/deep/.hide{
  display: none;
}
/deep/tr>td.el-table__expanded-cell{
  padding: 0 !important;
  border-bottom: none !important;
  .el-table{
    border: none;
  }
  .expandRow{
    background: #F6F8FA !important;
    td{
      position: relative;
      &:first-child::before{
        content: '';
        position: absolute;
        height: 1px;
        background: #F6F8FA !important;
        width: 15px;
        top: -1px;
        left: 0;
      }
      &:last-child::after{
        content: '';
        position: absolute;
        height: 1px;
        background: #F6F8FA !important;
        width: 15px;
        top: -1px;
        right: 0;
      }
    }
  }
}
/deep/.expandTableHeader{
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: none !important;
  th.is-leaf {
    border-bottom: none !important;
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: -0.15px;
    padding: 12px 15px 0 15px!important;
    color: #586069!important;
    .cell{
      padding-left: 0;
    }
  }
  tr{
    td{
      padding: 12px 15px!important;
      vertical-align: top;
      margin-right: 15px;
      .cell{
        line-height: 23px;
        position: relative;
        height: inherit;
        padding: 0;
      }
    }
  }
}
</style>